<template>
  <div class="result">
    <div class="code-container">
      <span>Your results</span>
      <div class="code">
        {{ code }}
      </div>
    </div>
    <h3 class="result-note">
      {{ new Date().toLocaleTimeString([], { year: "numeric", month: "numeric", day: "numeric", hour: '2-digit', minute:'2-digit'}) }}
    </h3>
    <p
      v-linkified
      class="result-note strong result1" 
      v-html="result1"
    />
    <p
      v-linkified
      class="result-note result2" 
      v-html="result2"
    />
    <p
      v-linkified
      class="result-note strong result3"
      v-html="result3"
    />
  </div>
</template>

<script>
export default {
  name: 'Result',
  data: function() {
    return {
      code: this.$route.params.code.substring(0, 2) || null,
      result1: null,
      result2: null,
      result3: null,
    };
  },
  mounted () {
    this.parseCode(this.code);
    this.setWithExpiry('philagov-covid-test', 'Done', 43200000); // 12 hour expiry
  },
  methods: {
    parseCode: function(code) {
      if(code == 'D1') {
        this.result1 = 'You should not return to work at this time. You must see a medical provider or provide a COVID-19 test result.';
        this.result2 = '<b>If you test positive for COVID-19</b>, stay home for at least 5 full days after symptoms started/restarted or testing positive if you did not have symptoms. Isolate from others. Wear a high-quality mask or respirator (e.g., N95, KN95, NIOSH equivalent, or double mask) when you must be around others at home and in public.<br/><br/>If your medical provider verifies and provides documentation that you do not have COVID, or if you test negative for COVID, you can return to work when you are no longer ill and have been fever free for 24 hours without medication. If your symptoms persist you should test at least every 48 hours until your symptoms resolve.';
        this.result3 = 'Regardless of vaccination status, you should isolate from others when you are sick and suspect that you have COVID-19 but do not yet have test results.<br/><br/> You must contact your HR Manager/Safety Officer/ Pandemic Coordinator to discuss your work status.';
      } else if(code == 'E1') {
        this.result1 = 'You may go to work. Follow the masking policy for your specific workplace.';
        this.result2 = 'Regardless of vaccination status, in the following settings you must wear a mask: <ul><li>In "patient-facing" settings: nurses providing medical care in City Health Centers or emergency medical personnel treating an individual regardless of the setting.</li><li>In congregate settings: for example, City prison or homeless shelter.</li><li>When riding in a City vehicle with others.</li><li>If you have an approved City medical or religious exemption, you must wear a high-quality mask or respirator (e.g., N95, KN95, NIOSH equivalent, or double mask) at all times except when eating or drinking.</li></ul>';
        this.result3 = '';
      } else if(code == 'E2') {
        this.result1 = '';
        this.result2 = `<b>Healthcare and Congregate Settings Employees</b><br/>
If you were a close contact and work in healthcare or congregate settings, consult your HR Manager/Safety Officer/Pandemic Coordinator for instructions. You may need to quarantine.<br/><br/>
<b>ALL OTHER CLOSE CONTACTS IN NON-HEALTHCARE/NON-CONGREGATE SETTINGS</b><br/><br/>
You may go to work. You are not required to quarantine because you are <b>a close contact and are asymptomatic</b> (do not currently have symptoms). <b>You must wear a high-quality mask or respirator (e.g., N95, KN95, NIOSH equivalent, or double mask)</b><b>for 10 days</b> from your last exposure. Start counting from Day 1.
<ul>
  <li><b>Day 1 is the first full day after your last exposure</b></li>
</ul>
<b>NOTE: You can still develop COVID-19 up to 10 days after you have been exposed.</b>
Watch for possible symptoms.<br/><br/>
<b>If you develop symptoms</b><br/>
<ul>
  <li>Isolate immediately for at least 5 full days after symptoms started/restarted and mask for an additional 5 days (days 6-10) after isolation</li>
  <li>Get a lab-based COVID-19 test as soon as possible</li>
  <li>Stay home until you know the result</li>
</ul>
<b>If you do not develop symptoms</b>, get a COVID-19 test the 6th day after you last had close contact with someone with COVID-19.<br/><br/>
<b>IF YOUR TEST IS POSITIVE</b><br/>
<b>If you test positive for COVID-19</b>, stay home for at least 5 full days after symptoms started/restarted or testing positive if asymptomatic, and isolate

from others. Wear a high-quality mask or respirator (e.g., N95, KN95, NIOSH equivalent, or double mask) when you must be around others at home and in public.<br/><br/>
When you have COVID-19, isolation is counted in days, as follows:<br/><br/>
<b>If you had no symptoms:</b>
<ul>
  <li>Day 1 is the first full day following the day you were tested</li>
</ul>
<b>If you had symptoms:</b>
<ul>
  <li>Day 1 is the first full day after the day your symptoms started</li>
</ul>
<b>You must contact your HR Manager/Safety Officer/ Pandemic Coordinator to discuss your work status.</b>`;
        this.result3 = '';
      } else if(code == 'F1') {
        this.result1 = `If you test positive and work in healthcare or congregate settings, consult your HR Manager/Safety Officer/Pandemic Coordinator for instructions. <br/><br/> If you work in general work settings (non-healthcare/non congregate settings) follow the instructions below:`;
        this.result2 = `<b>If you test positive for COVID-19</b>, stay home for at least 5 full days after symptoms started/restarted or testing positive if asymptomatic, and isolate from others. Wear a high-quality mask or respirator (e.g., N95, KN95, NIOSH equivalent, or double mask) when you must be around others at home and in public.
        <br/>
        <br/>
        <ul>
          <li>If after 5 days you are fever-free for 24 hours without the use of medication, and your symptoms are improving, or you never had symptoms, you may end isolation.</li>
          <li>Wear a mask at all times except when eating and drinking at work for 5 additional days. Eat alone at work. If employees cannot mask, they should wait 10 days before returning to work.</li>
          <li>Regardless of when you end isolation, avoid being around people who are more likely to get very sick from COVID-19 until at least day 10.</li>
        </ul>
`;
        this.result3 = `If you had no symptoms:
        <ul>
          <li>Day 1 is the first full day following the day you were tested. Start
counting here through your 5th day of isolation.</li>
        </ul>
If you had symptoms or later develop symptoms:
        <ul>
          <li>Day 1 is the first full day after the day your symptoms started. Start counting here through your 5th day of isolation.</li>
        </ul>
You must contact your HR Manager/Safety Officer/ Pandemic Coordinator to discuss your work status.`;
      }
      this.$gtag.event('view_item', {
        'event_category': 'employee-screener',
        'event_label': code,
      });
    },
    setWithExpiry: function(key, value, ttl) {
      const now = new Date();
      const item = {
        value: value,
        expiry: now.getTime() + ttl,
      };
      localStorage.setItem(key, JSON.stringify(item));
    },
  },
};
</script>
